import { select } from 'd3-selection'

export default class Widget {
    public $el: HTMLElement | null
    private readonly options: WidgetOptions

    constructor(options: WidgetOptions) {
        this.options = options
    }

    setEl(el: HTMLElement) {
        this.$el = el

        return this
    }

    updateTrajectoryLookup(value: string) {
        this.dashboarContext.actions.setFilterValues({
            ...this.dashboarContext.state.filterValues,
            trajectory: [value]
        })
    }

    getStorageKey(): string {
        if (Array.isArray(this.options.dashboardContext.state.filterValues.asset_name_event_type)) {
            return [
                'trajectory',
                this.options.id,
                ...this.options.dashboardContext.state.filterValues.asset_name_event_type
            ].join('/')
        } else {
            return ['trajectory', this.options.id].join('/')
        }
    }

    get dashboarContext() {
        return this.options.dashboardContext
    }

    get currentTrajectory(): string | null {
        const lookup = this.dashboarContext.state.filterValues
        if (Array.isArray(lookup.trajectory)) {
            return lookup.trajectory[0]
        } else {
            return null
        }
    }

    flow(type: string, events: Event[], layer: number, baseline: boolean, presentRedraw: boolean) {
        if (type == 'start') {
            console.log('start:', events)
        } else if (type == 'event' && layer == 0) {
            let current: string | null = this.currentTrajectory
            if (events.length > 0) {
                const filterValues = this.options.dashboardContext.state.filterValues

                if (!filterValues.hasOwnProperty('trajectory')) {
                    select(this.$el).selectAll('*').remove()

                    select(this.$el)
                        .selectAll('div.warning')
                        .data([null])
                        .join('div')
                        .classed('warning', true)
                        .html("Trajectory lookup isn't enabled for this dashboard.")

                    return
                }

                const saved = localStorage.getItem(this.getStorageKey())

                console.log(this.getStorageKey(), saved, current)

                // current don't exists; try saved
                if (!current && saved) {
                    current = saved
                }

                // not found on current list, select first item from list.
                if (events.filter(e => e.name == current).length == 0) {
                    current = events[0].name
                }

                // current is different from selected. Update the lookup and save on localStorage.
                if (current != this.currentTrajectory) {
                    if (current != saved) {
                        localStorage.setItem(this.getStorageKey(), current)
                    }
                    this.updateTrajectoryLookup(current)
                }
            }

            const self = this

            select(this.$el).style('padding', '10px').selectAll('label').data([null]).join('label').text('Trajectory:')

            console.log('events:', events)

            select(this.$el)
                .selectAll('select')
                .data([null])
                .join('select')
                .on('change', function () {
                    const value = select(this).property('value')
                    self.updateTrajectoryLookup(value)
                    localStorage.setItem(self.getStorageKey(), value)
                })
                .selectAll('option')
                .data([
                    {
                        uid: '',
                        name: events.length == 0 ? 'No trajectory available' : 'Select Trajectory'
                    },
                    ...(events || [])
                ])
                .join('option')
                // .style('margin', '0 5px 5px')
                .style('width', '50%')
                .text(d => d.name)
                .attr('value', d => d.name)

            select(this.$el)
                .selectAll('option')
                .filter(e => {
                    return e.name == current
                })
                .attr('selected', true)
        }
    }

    redraw() {}

    destroy() {
        select(this.$el).select('*').remove()
    }

    render() {
        if (typeof this.options.onReady === 'function') {
            this.options.onReady()
        }

        return this
    }
}
